module.exports = __webpack_public_path__ + "static/media/yardiemovie.cedbcc1e.jpg";